declare global {
	interface Window {
		loadingScripts: string[];
	}
}

window.loadingScripts = window.loadingScripts || [];

export function createScript(
	src: string,
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	onerror: () => void = () => {}
): HTMLScriptElement {
	const scriptElement = document.createElement('script');
	scriptElement.src = src;
	scriptElement.async = false;
	scriptElement.onload = (e) => {
		removeLoadingScript(src);
	};
	scriptElement.onerror = (e) => {
		console.error(e);
		removeLoadingScript(src);
		onerror();
	};
	window.loadingScripts.push(src);
	return scriptElement;
}

function removeLoadingScript(src: string) {
	const index = window.loadingScripts.indexOf(src);
	if (index > -1) {
		window.loadingScripts = window.loadingScripts.splice(index, 1);
	}
}
